var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgExpandHandle = function SvgExpandHandle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M22 .8V22H.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFDF",
    d: "M22 3v19H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    d: "m19.381 9.881 1.238 1.238-9.5 9.5-1.238-1.238zm0 5.5 1.238 1.238-4 4-1.238-1.238z"
  }))));
};

export default SvgExpandHandle;